import { render, staticRenderFns } from "./notificacion.vue?vue&type=template&id=63c0594d"
import script from "./notificacion.vue?vue&type=script&lang=js"
export * from "./notificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports